import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { Box, Typography } from "@mui/material";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useErrorHandler } from "react-error-boundary";
import InfiniteScroll from "react-infinite-scroll-component";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "underscore";
import {
  Alert,
  AlertAccount,
  AlertDDA,
  DefaultLoader,
  MenuBar,
  SavingDetailCard,
  Tooltip,
  Transaction,
  TransactionInfiniteLoader,
} from "../../components";
import { icons } from "../../constants";
import { NOT_ALLOWED_ACCOUNT_STATUS } from "../../constants/subaccount-status";
import withProfileRedirect from "../../containers/App/withProfileRedirect";
import { setCurrentEcddStatus } from "../../globalRedux/actions";
import { dataLayerGTM } from "../../utils/functions/dataLayerGTM";
import { transformMiniTransactions } from "../../utils/functions/transformMiniTransactions";
import {
  checkAcctStsCashIn,
  checkAcctStsCashOut,
} from "../../utils/functions/validationsDeposit";
import { useEcddChecking } from "../../utils/hooks";
import { getSubAccountInvest } from "../dashboard/redux/actions";
import { getRspDetail, setRSPPayload } from "../deposit/redux/action";
import {
  createFundSuccessV2,
  sendFundsCode,
  setIvestMinAmount,
  setSelectedFundCust,
} from "../fundSelection/redux/action";
import { setLastAmountInvest } from "../fundSelectionStep2/redux/actions";
import { resetSelectedPromo } from "../promoList/redux/action";
import { getTransactionHistory } from "../redux/action";
import { FUNDDETAILS } from "../redux/constant";
import { setCustFundDetail } from "./redux/action";
import "./style.scss";
import styles from "./styles";
import { ddaStatus, setRspButton, validateValue } from "./utils";
import { checkIfFundIsActive, checkIfFundIsTerminated } from "../../utils/functions/fundStatusChecker";
import { SWITCH_OUT_FUND_ERRORS, SwitchOutUnavailableAlert } from "../../components/SwitchOutUnavailableAlert";
import { CashOutUnavailableAlert } from "../../components/CashOutUnavailableAlert";

const liveAgentWhatsappNumberException1 =
    process.env.REACT_APP_LIVE_AGENT_WHATSAPP_NUMBER_EXCEPTION_1?.trim();

const CASH_IN_UNAVAILABLE_TYPES = {
  CASH_IN: "CASH_IN",
  AUTO_CASH_IN: "AUTO_CASH_IN",
}

const FundDetails = props => {
  const {
    history,
    match,
    transactionHistory,
    sendFundsCode,
    setIvestMinAmount,
    customerPortfolio,
    getSubAccountInvest,
    subAccStsInvest,
    subAccStsInvestLoading,
    riskProfileResult,
    setCustFundDetail,
    getTransactionHistory,
    loadingTransactionHistory,
    profile,
    ecddStatus,
    isEcddCompleted,
    setCurrentEcddStatus,
    resetSelectedPromo,
    setLastAmountInvest,
    createFundSuccessV2,
    setSelectedFundCust,
    getRspDetail,
    rspDetail,
    loadingRspDetail,
  } = props;

  const errorHandler = useErrorHandler();

  const [ddaPending, setDdaPending] = useState(false);
  const [rspSetup, setRspSetup] = useState({ edit: false, setup: false });
  const [isRiskProfileExpired, setRiskProfileExpired] = useState(false);
  const [isCashOutFundTerminated, setIsCashOutFundTerminated] = useState(false);
  const [switchOutFundError, setSwitchOutFundError] = useState("");
  const [disabledFundAction, setDisabledFundAction] = useState("");
  const [accountSts, setAccountSts] = useState({
    status: "Active",
    blockedCashIn: false,
    blockedCashout: false,
    blockedRsp: false,
    alert: false,
  });
  const [headAccSts, setHeadAccSts] = useState({
    alert: false,
    status: "Active",
  });
  const { handleCheckEcdd, status, onResetStatus } = useEcddChecking({
    ecddStatus,
    aml: profile &&
      profile.amlHistory.length > 0 &&
      typeof profile.amlHistory[0] === "object" && {
        result: profile.amlHistory[0].amlResult,
        status: profile.amlHistory[0].amlSts,
      },
    shouldNotPromptOnEffect: !isEcddCompleted,
  });

  const [showInfo, setShowInfo] = useState(false);
  const anchorRef = useRef(null);

  const [fundDetail] = useState(() => {
    const fund = customerPortfolio.find(
      portfolio => portfolio.fundCd === match.params.id
    );

    // in order for react error boundary to catch the error outside the render lifecycle
    // we'll intentionally throw error here in case portfolio is not found
    if (!fund) {
      errorHandler(
        `Cannot find the portfolio with fundCd of ${match.params.id}`
      );
    }

    return fund;
  });
  const [transactions, setTransactions] = useState([]);

  const pageNumber = useRef(1);
  const transactionsLength = useRef(0);

  const { numPages, totalPages } = transactionHistory;

  useEffect(() => {
    getRspDetail({
      cifPlanId: fundDetail.cifPlanId,
      fundCd: fundDetail.fundCd,
    });
    getSubAccountInvest(fundDetail.accountNo);

    getTransactionHistory(
      {
        page: pageNumber.current,
        size: 10,
        fundCd: fundDetail.fundCd,
        cifPlanId: fundDetail.cifPlanId,
      },
      transactionsResponse => {
        if (!transactionsResponse) return;

        const distributeMultipleFundDetails = transactionsResponse.reduce(
          (prev, { details, ...rest }) => {
            if (details.length > 1 && rest.type === "Buy") {
              for (const d of details) {
                if (fundDetail.fundCd === d.fundCode) {
                  prev.push({
                    ...rest,
                    plan: { ...rest.plan, planAlias: d.planAlias },
                    details: [d],
                    amount: d.amount,
                    actualAmt: d.actualAmt,
                  });
                }
              }
            } else {
              prev.push({ details, ...rest });
            }
            return prev;
          },
          []
        );

        transactionsLength.current += distributeMultipleFundDetails.length;

        setTransactions(prev => [
          ...transformMiniTransactions(distributeMultipleFundDetails, prev),
        ]);
      }
    );

    resetSelectedPromo();
    setLastAmountInvest();
    sessionStorage.removeItem("stopRsp");
    window.scrollTo({ top: 0 });
  }, []);

  useEffect(() => {
    if ("rspStatus" in fundDetail) {
      let knowTheStatus = setRspButton(fundDetail);
      setRspSetup(knowTheStatus);
    }

    setCustFundDetail(fundDetail);
  }, [fundDetail]);

  /**
   ** check if subaccount status is posible to do transaction
   ** start
   */

  useEffect(() => {
    let newObj = {
      status: "Active",
      alert: false,
      blockedCashIn: false,
      blockedCashout: false,
    };
    if ("sts" in subAccStsInvest) {
      let { sts } = subAccStsInvest;
      newObj.status = sts;
      let stopCashIn = checkAcctStsCashIn(sts);
      let stopCashOut = checkAcctStsCashOut(sts);
      if (!stopCashIn) {
        newObj.blockedCashIn = true;
      }
      if (!stopCashOut) {
        newObj.blockedCashout = true;
      }
      if (
        (rspSetup.setup || ["0", "21", "26"].includes(rspDetail.rspStatus)) &&
        NOT_ALLOWED_ACCOUNT_STATUS.includes(sts)
      ) {
        newObj.blockedRsp = true;
      }
      setAccountSts(newObj);
    }
  }, [subAccStsInvest, rspSetup, rspDetail]);

  const headAccountCheck = type => {
    const { headAccount } = profile;
    const accountStatus = headAccount?.sts;

    if (accountStatus) {
      const isSuspended = accountStatus === "Suspended";
      const isDeactivated = NOT_ALLOWED_ACCOUNT_STATUS.includes(accountStatus);

      if (isSuspended || isDeactivated) {
        if (isSuspended && (type === "cashOut" || type === "switch")) {
          return true;
        }
        if (
          headAccount.sts === "Closing" &&
          (type === "cashOut" || type === "switch")
        ) {
          return true;
        }
        if (
          type === "editRSP" &&
          !["0", "21", "26"].includes(rspDetail.rspStatus)
        ) {
          return true;
        }

        setHeadAccSts(prev => ({
          ...prev,
          alert: true,
          status: isSuspended ? "Suspended" : "Deactived",
        }));

        return false;
      }
    }

    return true;
  };

  /**
   * Cash-In
   ** check if subaccount status is posible to do transaction
   ** end
   */
  const handleDeposit = () => {
    if (!headAccountCheck()) {
      return;
    }
    if (accountSts.blockedCashIn) {
      setAccountSts({ ...accountSts, alert: true });
      return;
    }

    if (
      new Date() >=
      moment(riskProfileResult.expiredDate)
        .startOf("date")
        .toDate()
    ) {
      setRiskProfileExpired(true);
      return;
    }

    if (!checkIfFundIsActive(fundDetail.fund)) {
      setDisabledFundAction(CASH_IN_UNAVAILABLE_TYPES.CASH_IN);
      return;
    }

    const { fund = {} } = fundDetail;
    const {
      code = "",
      name = "",
      minSubsAmt = "10",
      salesFeePerc = "",
      serviceTaxPerc = "",
    } = fund;
    setIvestMinAmount(minSubsAmt);
    sendFundsCode([{ code, name, salesCharge: salesFeePerc, serviceTaxPerc }]);
    createFundSuccessV2({
      masteId: fundDetail.cifId,
      cifPlanId: fundDetail.cifPlanId,
      productId: fundDetail.product.id,
      accountNo: fundDetail.accountNo,
    });
    setSelectedFundCust(fundDetail.fund);

    history.push("/fund-selection-step-two");
  };

  // Cash-Out
  const handleWithdraw = () => {
    dataLayerGTM("click_tag", "Click", "Button", "Fund detail - Cash Out");

    if (!headAccountCheck("cashOut")) {
      return;
    }

    if (accountSts.blockedCashout) {
      setAccountSts({ ...accountSts, alert: true });
      return;
    }

    // Check if fund is terminated, if yes, show alert to user
    if(checkIfFundIsTerminated(fundDetail.fund)) {
      setIsCashOutFundTerminated(true);
      return;
    }

    sendFundsCode([
      {
        code: fundDetail.fund.code,
        name: fundDetail.fund.name,
        cifPlanId: fundDetail.cifPlanId,
        product: fundDetail.product,
        nav: fundDetail.nav.nav,
        unitHeld: fundDetail.unitHeld,
      },
    ]);
    history.push("/make-withdrawal");
  };

  // Auto Cash-In
  const handleRsp = () => {
    dataLayerGTM("click_tag", "Click", "Button", "Fund detail - RSP ");

    if (!checkIfFundIsActive(fundDetail.fund)) {
      setDisabledFundAction(CASH_IN_UNAVAILABLE_TYPES.AUTO_CASH_IN);
      return;
    }

    if ("rspStatus" in fundDetail) {
      let ddaResult = ddaStatus(fundDetail.rspStatus);
      if (ddaResult) {
        setDdaPending(ddaResult);
        return;
      }
    }

    if (accountSts.blockedRsp) {
      setAccountSts(prev => ({ ...prev, alert: true }));
      return;
    }

    props.setRSPPayload({
      cifPlanId: fundDetail.cifPlanId,
      fundCd: fundDetail.fund.code,
      target: "INVEST_RSP",
    });

    let rspSet = "setupRSP";
    if (rspSetup.edit) {
      rspSet = "editRSP";
    }
    if (!headAccountCheck(rspSet)) {
      return;
    }
    history.push(
      `/make-deposit/${FUNDDETAILS}/success/auto-deposit-v2/${rspSet}`
    );
  };

  // Switching
  const handleSwitching = () => {
    if (!headAccountCheck("switch")) {
      return;
    }
    // Switching is not allowed for terminated fund, so we will show the alert to user
    if(checkIfFundIsTerminated(fundDetail.fund)) {
      setSwitchOutFundError(SWITCH_OUT_FUND_ERRORS.FUND_TERMINATED);
      return;
    }
    history.push("/switching/create", {
      id: fundDetail.fundCd,
      productType: "invest",
    });
  };

  if (
    loadingRspDetail ||
    (loadingTransactionHistory && pageNumber.current === 1) ||
    subAccStsInvestLoading
  )
    return <DefaultLoader />;

  return (
    <div className="l-fund-details">
      <AlertDDA
        title="This Goal or Fund has already enabled Auto Cash In."
        firstText="Your Auto Cash In request is being processed, please come back and check the status later."
        isOpen={ddaPending}
        handleClose={() => setDdaPending(false)}
      />
      <AlertAccount
        title={`Account ${
          accountSts.status === "Suspended" ? "Suspended" : "Inactive"
        }`}
        firstText={
          accountSts.status === "Suspended"
            ? "Your account is currently suspended, we are unable to process your Cash In request however, you can still proceed with Cash Out."
            : "Your account is currently inactive, we're sorry for the inconvenience."
        }
        secondText={
          <span>
            For assistance, kindly contact our{" "}
            <span
              onClick={() => {
                setAccountSts({ ...accountSts, alert: false });

                window.my.call("openAppLink", {
                  url: `https://wa.me/${liveAgentWhatsappNumberException1}`,
                });
              }}
              style={{ color: "#1278CC" }}
            >
              Customer Care Centre.
            </span>
          </span>
        }
        isOpen={accountSts.alert}
        handleClose={() => setAccountSts({ ...accountSts, alert: false })}
      />
      <AlertAccount
        title={`Account ${
          headAccSts.status === "Suspended" ? "Suspended" : "Inactive"
        }`}
        firstText={
          headAccSts.status === "Suspended"
            ? "Your account is currently suspended, we are unable to process your Cash In request however, you can still proceed with Cash Out."
            : "Your account is currently inactive, we're sorry for the inconvenience."
        }
        secondText={
          <span>
            For assistance, kindly contact our{" "}
            <span
              onClick={() => {
                setHeadAccSts({ ...headAccSts, alert: false });

                window.my.call("openAppLink", {
                  url: `https://wa.me/${liveAgentWhatsappNumberException1}`,
                });
              }}
              style={{ color: "#1278CC" }}
            >
              Customer Care Centre.
            </span>
          </span>
        }
        isOpen={headAccSts.alert}
        handleClose={() => setHeadAccSts({ ...headAccSts, alert: false })}
      />
      <Alert
        title={`${disabledFundAction === CASH_IN_UNAVAILABLE_TYPES.CASH_IN ? "Cash in" : "Auto cash in"} unavailable`}
        description="New investments are no longer accepted for this fund. Explore other available funds to continue investing."
        isOpen={!!disabledFundAction}
        btnTxt="Ok"
        handleAction={() => setDisabledFundAction("")}
        handleCancel={() => setDisabledFundAction("")}
      />
      <Alert
        title="Your risk profile is expired"
        description="Risk Profile has expired, please perform Risk Assessment"
        isOpen={isRiskProfileExpired}
        isCancel
        btnTxt="Ok"
        handleAction={() => {
          history.push("/invest-introduction");
        }}
        handleCancel={() => setRiskProfileExpired(false)}
      />
      <Alert
        title="Account Verification"
        description="Thank you for submitting your information. We need to perform further verification to activate your account."
        isOpen={status === "pending"}
        isCS="https://principal.com.my"
        isCancel={false}
        btnTxt="Chat with us on WhatsApp"
        handleAction={() => {
          setCurrentEcddStatus(false);
          onResetStatus();
          window.my.call("openAppLink", {
            url: `https://wa.me/${liveAgentWhatsappNumberException1}`,
          });
        }}
        handleCancel={() => {
          setCurrentEcddStatus(false);
          onResetStatus();
        }}
      />
      <Alert
        title="Your account is deactivated"
        description="So sorry, your account is deactivated. We need to perform a verification to activate your account."
        isOpen={status === "rejected"}
        isCS="https://principal.com.my"
        isCancel={false}
        btnTxt="Chat with us on WhatsApp"
        handleAction={() => {
          onResetStatus();
          window.my.call("openAppLink", {
            url: `https://wa.me/${liveAgentWhatsappNumberException1}`,
          });
        }}
        handleCancel={onResetStatus}
      />
      <SwitchOutUnavailableAlert
        switchOutFundError={switchOutFundError}
        isOpen={!!switchOutFundError}
        onClose={() => setSwitchOutFundError("")}
      />
      <CashOutUnavailableAlert
        isOpen={isCashOutFundTerminated}
        onClose={() => setIsCashOutFundTerminated(false)}
      />
      <div className="l-fund-details__wrapper">
        <div className="l-fund-details__fund">
          <div className="l-fund-details__top-wrapper">
            <ArrowBackOutlinedIcon
              sx={{ cursor: "pointer", color: "#ffffff", fontSize: 24 }}
              onClick={() => history.back()}
            />
            <div
              className="l-fund-details__info"
              onClick={() => {
                dataLayerGTM(
                  "click_tag",
                  "Click",
                  "Link",
                  "Fund detail - Fund info"
                );
                window.my.navigateTo({
                  url:
                    "/pages/link/link?url=" +
                    encodeURIComponent(fundDetail?.fund?.fundInfoUrl),
                });
              }}
            >
              <img src={icons.fundInfo} alt="fund info" />
              <p>Fund info</p>
            </div>
          </div>

          <h1 className="l-fund-details__name">{fundDetail.fund.name}</h1>
          <h2 className="l-fund-details__total-asset">
            RM{" "}
            <NumberFormat
              value={fundDetail.currentValue || 0}
              thousandSeparator
              displayType="text"
              decimalScale={2}
              fixedDecimalScale
            />
          </h2>
          <p className="l-fund-details__total-returns">
            Total returns:{" "}
            <span>
              {Number(fundDetail.totalGain) < 0 ? "-" : "+"}RM
              <NumberFormat
                value={validateValue(fundDetail.totalGain, "NUMBER")}
                thousandSeparator
                displayType="text"
                decimalScale={2}
                fixedDecimalScale
              />
            </span>
          </p>
          <span className="l-fund-details__last-update">
            Last update:{" "}
            {moment(validateValue(fundDetail.lastUpdated, "DATE"))
              .utcOffset("+0800")
              .format("DD MMM YYYY, h:mm A")}
          </span>

          <div className="l-fund-details__grid">
            <SavingDetailCard
              labelStyle={{ width: "100%", marginBottom: "5px" }}
              label={
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>
                    Indicative Net <br />
                    Asset Value
                  </span>
                  <Tooltip
                    copywriting={`As of ${moment(fundDetail.lastUpdated)
                      .utcOffset("+0800")
                      .format("DD MMMM YYYY")}`}
                    isActive={showInfo}
                    callback={e => {
                      const target = e.target;
                      if (target.classList.contains("tooltip-text")) return;
                      setShowInfo(false);
                    }}
                    tooltipRef={anchorRef}
                    anchor={
                      <img
                        className="tooltip-anchor"
                        alt="Tooltip info"
                        src={icons.infoSvg}
                        ref={anchorRef}
                        onClick={() => {
                          setShowInfo(prev => !prev);
                        }}
                        style={{
                          width: "20px",
                          height: "20px",
                        }}
                      />
                    }
                  />
                </span>
              }
              decimalSet={4}
              needNumberFormat={true}
              detail={validateValue(fundDetail.nav.nav, "NUMBER")}
            />
            <SavingDetailCard
              label={
                <>
                  Number of <br /> Units
                </>
              }
              labelStyle={{ marginBottom: "5px" }}
              decimalSet={4}
              needNumberFormat={true}
              detail={validateValue(fundDetail.unitHeld, "NUMBER")}
            />
          </div>
        </div>
        <Box
          sx={{
            backgroundColor: "#f6f6f8",
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {transactions && transactions.length > 0 && (
            <Typography
              style={{
                ...styles.baseFont,
                padding: "16px 16px 0",
                color: "#616367",
              }}
            >
              You can refer to your Cash In or Cash Out under processing at{" "}
              <span
                style={{ color: "#1278CC" }}
                onClick={() => history.push("/transaction")}
              >
                transaction history
              </span>
              .
            </Typography>
          )}
          {transactions && transactions.length > 0 ? (
            <InfiniteScroll
              dataLength={transactionsLength.current}
              style={{ paddingBottom: "8rem" }}
              next={() => {
                if (window.scrollY === 0) return;

                getTransactionHistory(
                  {
                    page: (pageNumber.current += 1),
                    size: 10,
                    fundCd: fundDetail.fundCd,
                    cifPlanId: fundDetail.cifPlanId,
                  },
                  transactionsResponse => {
                    if (!transactionsResponse) return;
                    const distributeMultipleFundDetails = transactionsResponse.reduce(
                      (prev, { details, ...rest }) => {
                        if (details.length > 1 && rest.type === "Buy") {
                          for (const d of details) {
                            if (fundDetail.fundCd === d.fundCode) {
                              prev.push({
                                ...rest,
                                plan: { ...rest.plan, planAlias: d.planAlias },
                                details: [d],
                                amount: d.amount,
                                actualAmt: d.actualAmt,
                              });
                            }
                          }
                        } else {
                          prev.push({ details, ...rest });
                        }
                        return prev;
                      },
                      []
                    );

                    transactionsLength.current +=
                      distributeMultipleFundDetails.length;

                    setTransactions(prev => [
                      ...transformMiniTransactions(
                        distributeMultipleFundDetails,
                        prev
                      ),
                    ]);
                  }
                );
              }}
              hasMore={numPages < totalPages}
              loader={
                loadingTransactionHistory &&
                pageNumber.current > 1 && (
                  <TransactionInfiniteLoader style={{ marginTop: "30px" }} />
                )
              }
            >
              <Transaction transactions={transactions} />
            </InfiniteScroll>
          ) : (
            <Box
              sx={{
                lineHeight: 1.38,
                color: "#616367",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "auto 0",
              }}
            >
              <div>
                You can refer to your Cash In or Cash Out under processing at{" "}
                <span
                  style={{ color: "#1278CC" }}
                  onClick={() => history.push("/transaction")}
                >
                  transaction history
                </span>
                .
                <br />
                Start Cash In now.
              </div>
            </Box>
          )}
        </Box>
      </div>

      {/* Bottom bar */}
      <div />
      <div className="l-fund-details__menu-bar">
        <MenuBar
          rspText={rspSetup.edit ? "Edit" : "Auto Cash In"}
          handleSwitching={handleCheckEcdd({
            cb: handleSwitching,
            ecddExpiredCb: () => history.push("/onBoarding/ecdd/FUNDDETAILS"),
            gtm: {
              event: "click_tag",
              action: "Click",
              category: "Button",
              label: "Fund detail - Switching",
            },
          })}
          handleWithdraw={handleWithdraw}
          handleDeposit={handleCheckEcdd({
            cb: handleDeposit,
            ecddExpiredCb: () => history.push("/onBoarding/ecdd/FUNDDETAILS"),
            gtm: {
              event: "click_tag",
              action: "Click",
              category: "Button",
              label: "Fund detail - Cash In",
            },
          })}
          handleAutoDeposit={handleRsp}
          isBackgroundGrayed
        />
      </div>
    </div>
  );
};

const withConnect = connect(
  state => ({
    ...state.dashboardReducer,
    transactionHistory: state.goal.transactionHistory,
    customerPortfolio: state.dashboardReducer.customerPortfolio,
    riskProfileResult: state.riskAssessmentReducer.riskProfileResult,
    loadingTransactionHistory: state.goal.loadingTransactionHistory,
    ecddStatus: state.goal.ecddStatus,
    profile: state.goal.profile,
    isEcddCompleted: state.commingFromReducer.isEcddCompleted,
    rspDetail: state.autoDepositReducer.rspDetail,
    loadingRspDetail: state.autoDepositReducer.loadingRspDetail,
  }),
  {
    sendFundsCode,
    setIvestMinAmount,
    getSubAccountInvest,
    setRSPPayload,
    setCustFundDetail,
    setCurrentEcddStatus,
    getTransactionHistory,
    resetSelectedPromo,
    setLastAmountInvest,
    createFundSuccessV2,
    setSelectedFundCust,
    getRspDetail,
  }
);

export default compose(
  withRouter,
  withConnect,
  withProfileRedirect
)(FundDetails);
